import React from 'react';
import { createComponent } from '@lit/react';
import { IxTimer as IxTimerLit } from '../IxTimer.js';

customElements.define('ix-timer', IxTimerLit);

export const IxTimer = createComponent({
  tagName: 'ix-timer-react',
  elementClass: IxTimerLit,
  react: React,
});
